module.exports = __webpack_public_path__ + "static/media/search.b20f1cb7.svg";